module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/301439e2e5ab88b658368ee525e6752b.svg";